import { type CSSProperties, memo } from 'react';
import { useSelector } from 'react-redux';

import { selectJettonStatus } from '@/entities/jetton';
import { useJoinGame } from '@/shared/lib/hooks/useJoinGame';
import { useTelegramBackButton } from '@/shared/lib/telegram/useTelegramBackButton';

import { BetPanel, CrashHistory, JettonPlayer, LivePlayers } from './ui';

export const JettonPage = memo(() => {
  useTelegramBackButton();
  useJoinGame('jetton');
  const jettonStatus = useSelector(selectJettonStatus);

  return (
    <div className="game-page">
      <CrashHistory />

      <div className="game-page__canvas-wrap" style={{ height: 260, borderRadius: 'var(--radius-xl)', overflow: 'hidden' }}>
        <JettonPlayer status={jettonStatus} />
      </div>

      <div className="game-page__controls">
        <div className="game-page__fade-in" style={{ '--fade-in-delay': '0.1s' } as CSSProperties}>
          <BetPanel />
        </div>

        <div className="game-page__fade-in" style={{ '--fade-in-delay': '0.2s' } as CSSProperties}>
          <LivePlayers />
        </div>
      </div>
    </div>
  );
});

export { JettonPage as default };
